
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { dispatchEventBus } from '@appbase/util/eventBus'
import WebpartListItem from './WebpartListItem.vue'

@Component({
    components: { WebpartListItem },
})
export default class WebpartList extends Vue {
    @Prop({ type: Array }) webparts?: webpartv3.Webpart[]

    /** 회사 코드 */
    @Prop({ type: String, required: true }) company!: string
    @Prop({ type: String, default: 'ko-KR'}) userLang!: string

    /** 현재 로그인된 사용자의 애플리케이션 데이터 */
    current!: account.TCurrent
}
